<template>
  <div class="animated fadeIn pt-4">
    <template v-if="showFilters">
      <section-header :title="filtersTitle">
        <button
          class="btn btn-primary float-right"
          @click.prevent="toggleFilters()">
          <i class="fa fa-fw fa-times"></i>
          Nascondi filtri
        </button>
      </section-header>
      <slot name="filters">
        <b-card>Filtri di ricerca</b-card>
      </slot>
      <div class="text-right mb-4">
        <options-form-field
          v-if="pageRequest"
          class="float-left"
          dropdown
          :value="pageRequest.size"
          :options="pageSizeOptions"
          @input="$emit('selectPageSize', $event)">
        </options-form-field>
        <b-button variant="success" @click.prevent="$emit('find')">
          <i class="fa fa-fw fa-search"></i> Cerca
        </b-button>
      </div>
      <debug-panel>{{ { pageRequest, filters } }}</debug-panel>
    </template>

    <section-header :title="resultsTitle">
      <sort-box
        :items="sorters"
        :sort="page && page.sortedBy"
        :dir="page && page.sortOrder"
        class="float-right"
        @sort="$emit('sort', $event)">
      </sort-box>
      <b-button
        v-if="!showFilters"
        variant="primary"
        class="float-right mr-2"
        @click.prevent="toggleFilters()">
        <i class="fa fa-fw fa-search"></i>
        Mostra filtri
      </b-button>
    </section-header>
    <template v-if="results && results.length">
      <slot name="results"></slot>
      <pager :page="page" @input="$emit('selectPage', $event)"></pager>
    </template>
    <template v-else>
      <b-card>{{ noResultsMessage }}</b-card>
    </template>
    <slot name="bottom-buttons"></slot>
    <div class="mb-4"></div>
    <slot name="debug">
      <debug-panel>{{ page }}</debug-panel>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      default: () => undefined
    },

    sorters: {
      type: Array,
      default: () => []
    },

    pageRequest: {
      type: Object,
      default: undefined
    },

    filters: {
      type: Object,
      default: undefined
    },

    page: {
      type: Object,
      default: undefined
    },

    filtersTitle: {
      type: String,
      required: true
    },

    resultsTitle: {
      type: String,
      required: true
    },

    resultsField: {
      type: String,
      default: 'content'
    },

    noResultsMessage: {
      type: String,
      required: true
    },

    pageSizeOptions: {
      type: Array,
      default: () => [
        { value: 0, text: "Tutti i risultati" },
        { value: 2   , text: "2 risultati/pagina" },
        { value: 20  , text: "20 risultati/pagina" },
        { value: 50  , text: "50 risultati/pagina" },
        { value: 100 , text: "100 risultati/pagina" }
      ]
    }
  },

  data() {
    return {
      showFilters: true,
    };
  },

  computed: {
    results() {
      return this.page && this.page[this.resultsField];
    }
  },

  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
  }
};
</script>
